import React, { useEffect, useState, PureComponent } from 'react';

import ReactPlayer from "react-player";

import { ReactComponent as QrcodePurple } from '../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';

import ActivityIcon from './ActivityIcon';

export default function Quiz ({type, activity, remove, errors, register, name, icon, saveIcon, hideIcon}) {
    
    const [video, setVideo] = useState(false);    
    const LoadVideo = (event) => {
        setVideo(event.target.value);
    };    
    
    return (
        
        <>
        
            <div className="title"> 
                <div>
                    <div className="icon"><img src={icon} alt="" /></div>
                    <div className="name">Settings {name}</div>
                </div>
                <div>
                    <div className="icon qrcode"><QrcodePurple /></div>
                    <div className="icon remove" onClick={remove}><Remove /></div>
                </div>
            </div>

            <ActivityIcon icon={icon} saveIcon={saveIcon} hideIcon={hideIcon} />
            
            <label>Enter {name} name</label>
            <input 
                type="text"
                {...register("name", { required: "Name is required" })}
                placeholder={name + " name"}
                defaultValue={activity['name']}
            />
            <div className="error">{errors.name?.message}</div>                                
            
            <label>Video link</label>
            <input
                type="text"
                {...register("data[url]", { required: "Link is required" })}
                defaultValue={activity['data']['url']}
            />


            {/*
            <input type="text" placeholder="" onChange="LoadVideo" />
            
            {video ? <ReactPlayer url="https://www.youtube.com/watch?v=5oO_wcovdtU" /> : null }    
            */}
            
        </>
        
    )

}        
        
